export default __webpack_public_path__ + "static/media/budget-wishlist.ef371f1c.png";